/**
 * Converts minutes to milliseconds for use as stale time in Vue Query.
 * @param {Object} options - The options object.
 * @param {number} options.minutes - The number of minutes to convert.
 * @returns {number} The number of milliseconds equivalent to the provided minutes.
 */
export const convertToStaleTime = ({ minutes }) => minutes * (1000 * 60);

/**
 * Converts minutes to milliseconds for use as cache time in Vue Query.
 * @param {Object} options - The options object.
 * @param {number} options.minutes - The number of minutes to convert.
 * @returns {number} The number of milliseconds equivalent to the provided minutes.
 */
export const convertToCacheTime = ({ minutes }) => minutes * (1000 * 60);
export const createQueryKey = (objectKey) => Object.freeze(objectKey);
